import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LandingPage.module.css';

const LandingPage = () => {
    const navigate = useNavigate();
    const videoRef = React.useRef(null);
    const [showIntro, setShowIntro] = useState(true);

    useEffect(() => {
        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.pause();
            videoElement.currentTime = 0;
        }

        const timerPlay = setTimeout(() => {
            if (videoElement) {
                videoElement.play().catch(e => console.error("Play error:", e));
            }
            setShowIntro(false);
        }, 3000); // Play video and remove image at 3s

        return () => {
            clearTimeout(timerPlay);
        };
    }, []);

    const handleEnter = () => {
        navigate('/home');
    };

    return (
        <div className={styles.landingContainer}>
            <video
                ref={videoRef}
                className={styles.videoBackground}
                muted
                playsInline
                loop
            >
                <source src="/videos/Landing_page_video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {showIntro && (
                <img
                    src="/images/Landing_page/Landing_page_image.webp"
                    alt="Intro"
                    className={styles.introImage}
                />
            )}

            <div className={styles.overlay}>
                <div className={styles.content}>
                    <h1 className={styles.title}>Highview House</h1>
                    <button onClick={handleEnter} className={styles.enterButton}>
                        Enter
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
